import { render, staticRenderFns } from "./NoDataContainer.vue?vue&type=template&id=08cf7877&"
import script from "./NoDataContainer.vue?vue&type=script&lang=js&"
export * from "./NoDataContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports